// extracted by mini-css-extract-plugin
module.exports = {"button":"clearButtonStyles_button__RJ_0H","buttonKeyboardFocused":"clearButtonStyles_buttonKeyboardFocused__29ZNF"};